(function () {
  var config = window.neohSoldOut;
  if (!config) return;

  var market = config.market;
  var variants = config.variants || {};

  var soldOutLabel = (window.theme && window.theme.strings && window.theme.strings.soldOut)
    ? window.theme.strings.soldOut
    : 'Ausverkauft';

  function isVariantSoldOut(variantId) {
    var v = variants[String(variantId)];
    if (!v) return false;
    if (market === 'at' && v.soldOutAt === true) return true;
    if (market === 'deutschland' && v.soldOutDe === true) return true;
    return false;
  }

  function getVariantIdFromUrl() {
    var match = window.location.search.match(/variant=(\d+)/);
    return match ? match[1] : null;
  }

  function getVariantIdFromSelect() {
    var select = document.querySelector('select[data-product-select]');
    return select ? select.value : null;
  }

  function updateButton() {
    var variantId = getVariantIdFromUrl() || getVariantIdFromSelect();
    var btn = document.querySelector('button[name="add"][data-add-to-cart]');
    if (!btn) return;

    if (variantId && isVariantSoldOut(variantId)) {
      btn.disabled = true;
      var textEl = btn.querySelector('[data-add-to-cart-text]');
      if (textEl) {
        textEl.textContent = soldOutLabel;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateButton);
  } else {
    updateButton();
  }

  var lastUrl = location.href;
  setInterval(function () {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(updateButton, 100);
    }
  }, 300);

})();